import { getLanguages } from "./util.js";

const setActiveBreadcrumbLanguage = (language) => {
  const languageSelectors = {
    en: ".bilingual-english",
    fr: ".bilingual-french",
  };

  // Set active class on breadcrumb itself
  const breadcrumb = document.querySelector("#label-options-breadcrumb");
  if (!breadcrumb) {
    console.warn("Bilingual breadcrumb not found");
    return;
  }

  breadcrumb.querySelectorAll("li").forEach((e) => e.classList.remove("is-active"));
  const activeLi = breadcrumb.querySelector(`li${languageSelectors[language]}`);
  if (activeLi) {
    activeLi.classList.add("is-active");
  }

  // Show/hide form fields
  const bilingualFields = document.querySelectorAll(`[data-bilingual-field]`);

  bilingualFields.forEach((el) => {
    // Only toggle fields that are inside a panel (to avoid affecting other bilingual elements)
    if (el.closest(".panel")) {
      if (el.getAttribute(`data-bilingual-field`) == language) {
        el.classList.remove("is-hidden");
      } else {
        el.classList.add("is-hidden");
      }
    }
  });
};

export const syncBilingualControlsWithLabel = () => {
  const languages = getLanguages();
  if (languages.length === 1) {
    setActiveBreadcrumbLanguage(languages[0]);
  }
};

export const initializeBilingualBreadcumbControl = () => {
  const languages = getLanguages();

  if (languages.length === 0) {
    console.warn("No languages available for bilingual control");
    return;
  }

  const breadcrumb = document.querySelector("#label-options-breadcrumb");
  if (!breadcrumb) {
    console.warn("Bilingual breadcrumb element not found during initialization");
    return;
  }

  setActiveBreadcrumbLanguage(languages[0]);

  // Remove any existing click handler on the breadcrumb to avoid duplicates
  const clickHandler = (event) => {
    const languageLink = event.target.closest("[data-language]");
    if (languageLink && breadcrumb.contains(languageLink)) {
      event.preventDefault();
      setActiveBreadcrumbLanguage(languageLink.dataset["language"]);
    }
  };

  // Store the handler reference so we can remove it later if needed
  if (breadcrumb._bilingualClickHandler) {
    breadcrumb.removeEventListener("click", breadcrumb._bilingualClickHandler);
  }
  breadcrumb._bilingualClickHandler = clickHandler;
  breadcrumb.addEventListener("click", clickHandler);
};
